/**
 * Contract for the Alliance PDF assistant (RAG) service.
 * Mirrors the .NET API in the alliance-resource-chatbot repo.
 */

export enum DocumentIndexStatus {
  /** Chunks are embedded and queryable. */
  Indexed = 'indexed',
  /** Queued or mid-ingest. Poll until it resolves. */
  Pending = 'pending',
  /** No extractable text (e.g. an image-only scan we cannot OCR). */
  Unsupported = 'unsupported',
  /** Ingest failed permanently. Surface a retry. */
  Failed = 'failed'
}

export interface DocumentStatus {
  resourceId: string;
  status: DocumentIndexStatus;
  pageCount: number | null;
  indexedAt: string | null;
}

export interface DocumentFaqEntry {
  question: string;
  answer: string;
}

/**
 * Generated once at ingest time and cached server-side, so opening the
 * dialog is a read rather than three model calls.
 */
export interface DocumentInsights {
  resourceId: string;
  /** Sanitised HTML. */
  overview: string;
  faq: DocumentFaqEntry[];
  suggestedQuestions: string[];
  generatedAt: string;
}

/**
 * A retrieved chunk backing part of an answer. `index` is 1-based and
 * matches the [n] markers the model emits, so citations can be linked
 * back to the passage they came from.
 */
export interface AnswerSource {
  index: number;
  pageNumber: number;
  sectionHeading: string | null;
  snippet: string;
  score: number;
}

export interface ConversationCreated {
  conversationId: string;
}

export type AskPdfStreamEvent =
  | { type: 'sources'; sources: AnswerSource[] }
  | { type: 'token'; text: string }
  | { type: 'done'; messageId: string }
  | { type: 'error'; message: string; code?: string };
